import { ApiEntity } from "../../Api/api.model";
import { string, type, array, enums, number } from "superstruct";
import { validateStruct } from "../../../utils/validate";
import { Schedule } from "./Challenge.interface";

interface score {
    type: Schedule,
    zenPoints: number,
    zenBonus: number,
    name: string
}

export interface Gamification {
    scoring: Array<score>
}

const lowerCaseScoringType = (scoring: Array<score>) => {
    return scoring.map(score => ({ ...score, type: score.type.toLowerCase() }))
}

const GamificationStruct = type({
    scoring: array(type({
        type: enums([
            "monthly",
            "daily",
            "weekly",
            "biweekly",
            "threedaysaweek",
        ] as Array<Schedule>),
        zenPoints: number(),
        darePenalty: number(),
        dareRecovery: number(),
        zenBonus: number(),
        name: string()
    })),
});

export class GamificationEntity extends ApiEntity<Array<Gamification>> {
    constructor() {
        super("gamification", 'single');
    }
    validate(rawData: Array<unknown>): Array<Gamification> {
        console.log('Gamification data:', rawData);
        return rawData.map((rawItem) =>
            validateStruct<Gamification>(rawItem, GamificationStruct, this.endPoint, [
                { field: 'scoring', transform: lowerCaseScoringType },
            ])
        );
    }
}
